export const PUBLIC_CANNABIS_CARD_TIMEOUT = 600000;
export const CANNABIS_CARD_LOCAL_STORAGE_ITEM = 'canncall';